/**
 * Lazy-load below-the-fold sections on product page.
 * Keeps section HTML in the page, but defers media work until scroll approaches it.
 */
(function () {
  'use strict';

  var rootMargin = '900px 0px';
  var threshold = 0.01;

  function loadDeferredResources(section) {
    if (!section) return;
    if (section.dataset.lazyLoaded) return;
    section.dataset.lazyLoaded = 'true';
    section.classList.remove('lazy-section-pending');

    // Load deferred images (data-src -> src, data-srcset -> srcset)
    section.querySelectorAll('img[data-src]').forEach(function (img) {
      var src = img.dataset.src;
      if (src) {
        img.src = src;
        img.removeAttribute('data-src');
      }
      var srcset = img.dataset.srcset;
      if (srcset) {
        img.srcset = srcset;
        img.removeAttribute('data-srcset');
      }
    });

    // Load deferred video sources (data-src on source element)
    section.querySelectorAll('video source[data-src]').forEach(function (source) {
      var src = source.dataset.src;
      if (src) {
        source.src = src;
        source.removeAttribute('data-src');
        var video = source.closest('video');
        if (video) {
          video.load();
          if (video.autoplay && video.paused) {
            var playPromise = video.play();
            if (playPromise && playPromise.catch) playPromise.catch(function () {});
          }
        }
      }
    });

    section.classList.add('lazy-section-loaded');
  }

  window.dtLoadLazySection = loadDeferredResources;

  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('[data-lazy-section]').forEach(loadDeferredResources);
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          loadDeferredResources(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: rootMargin, threshold: threshold }
  );

  function init() {
    document.querySelectorAll('[data-lazy-section]').forEach(function (section) {
      section.classList.add('lazy-section-pending');
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
